import type { KaspreadsheetProduct } from '@/mocks/kaspreadsheet-products';

interface ProductCardProps {
  product: KaspreadsheetProduct;
}

export default function ProductCard({ product }: ProductCardProps) {
  return (
    <a
      href={product.url}
      target="_blank"
      rel="noopener nofollow"
      className="group block bg-white rounded-xl border border-background-200 overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
      data-product-shop="true"
    >
      <div className="relative aspect-square overflow-hidden bg-background-100">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
          onError={(e) => {
            (e.target as HTMLImageElement).src = 'https://readdy.ai/api/search-image?query=minimal%20elegant%20product%20placeholder%20with%20soft%20neutral%20background%20clean%20aesthetic&width=400&height=400&seq=product-fallback-1&orientation=squarish';
          }}
        />
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm font-medium text-foreground-800 leading-snug line-clamp-2 min-h-[2.5rem] mb-2">
          {product.name}
        </h3>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-base font-bold text-primary-600">{product.price}</span>
            <span className="text-xs text-foreground-500">{product.usdPrice}</span>
          </div>
          <span className="text-xs font-medium text-secondary-600 bg-secondary-100 px-2 py-1 rounded-md">
            {product.category}
          </span>
        </div>
        <div className="mt-3 flex items-center gap-1.5 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
          <span>View Product</span>
          <i className="ri-external-link-line text-sm" />
        </div>
      </div>
    </a>
  );
}